import { Login } from './Entities/Login';
import { ActivatedRoute } from '@angular/router';
import { AfterViewInit, Component, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { AuthService } from './Services/auth.service';
import { MenuService } from './Services';
import { ModalLoginComponent } from './shared/components/modal-login/modal-login.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnChanges, AfterViewInit {
  title = 'FibraInnSupplierWebPublic';
  @ViewChild('modalLogin') modalLogin?: ModalLoginComponent;

  constructor(
    public authService: AuthService,
    private menuService: MenuService
  ) {

  }

  ngAfterViewInit(): void {
    let mostrar_modal = false;
    let mostrar_modal_nuevo_repse = false;
    let tipo_bloqueo = '';
    let tipo = '';

    const bloqueRepseInicial = localStorage.getItem('BLOQUEO-REPSE-INICIAL');
    const bloqueRepse = localStorage.getItem('BLOQUEO-REPSE');
    const tieneSolRepse = localStorage.getItem('NUEVA-SOL-REPSE');
    const tieneSolRepseIncial = localStorage.getItem('NUEVA-SOL-REPSE-INICIAL');
    const periodosPendientes = localStorage.getItem('NUEVA-SOL-REPSE-PERIODOS');

    if (bloqueRepseInicial) {
      if (bloqueRepseInicial == '1') {
        mostrar_modal = true;
        tipo_bloqueo = 'INICIAL';
      }
    }
    else if (bloqueRepse) {
      if (bloqueRepse == '1') {
        mostrar_modal = true;
        tipo_bloqueo = 'RECURRENTE';
      }
    }
    else if (tieneSolRepse) {
      if (tieneSolRepse == '1') {
        mostrar_modal_nuevo_repse = true;
        tipo = 'RECURRENTE';
      }
    }
    else if (tieneSolRepseIncial) {
      if (tieneSolRepseIncial == '1') {
        mostrar_modal_nuevo_repse = true;
        tipo = 'INICIAL';
      }
    }

    if (mostrar_modal) {
      Swal.fire({
        title: "<strong>BLOQUEO <u>REPSE</u></strong>",
        icon: "info",
        html: `Se le informa que su usuario tiene un <b>Bloqueo REPSE ${tipo_bloqueo}</b> por
            <a href="#/negocio_proveedores/repse/list" autofocus style='color:red;'>Solicitudes Pendientes: </a><br> <i style='color:orange-dark;'>${tipo_bloqueo == 'RECURRENTE' ? '[ ' + periodosPendientes + ']' : ''}<br></i>,
            que no ha completado, por lo que <b>no podrá realizar Cargas y Validaciones de Facturas de Entrada</b> hasta que sea desbloqueado, revise su apartado REPSE en el MENU .`,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: `
            <i class="fa fa-thumbs-up"><a style="color:white;" href="#/negocio_proveedores/repse/list" autofocus> ${tipo_bloqueo == 'INICIAL' ? 'Revisar Solicitud Inicial REPSE' : 'Revisar Solicitudes REPSE'} </a></i> 
          `,
        confirmButtonAriaLabel: "Thumbs up, great!",
        cancelButtonText: `
            <i class="fa fa-thumbs-up"> Enterado</i>
          `,
        cancelButtonAriaLabel: "Thumbs down"
      });
    }
    else if (mostrar_modal_nuevo_repse) {
      Swal.fire({
        title: `<strong>NUEVA SOLICITUD <u>REPSE ${tipo}</u></strong>`,
        icon: "info",
        html: `Se le informa que su usuario tiene una <b>Nueva Solicitud REPSE ${tipo}</b> <i>${tipo == 'RECURRENTE' ? '[' + periodosPendientes + ']' : ''}</i> puede consultar su apartado de 
            <a href="#/negocio_proveedores/repse/list" autofocus>Solicitudes Pendientes</a>,
            para realizar la carga de los documentos solicitados, <b>es importante que cumpla en tiempo y forma esta solicitud</b>, revise su apartado REPSE en el MENU PRINCIPAL. `,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: `<i class="fa fa-thumbs-up"><a style="color:white;" href="#/negocio_proveedores/repse/list" autofocus>'Ver Nueva Solicitud REPSE' </a></i> `,
        confirmButtonAriaLabel: "Thumbs up, great!",
        cancelButtonText: `<i class="fa fa-thumbs-up"> Enterado</i>`,
        cancelButtonAriaLabel: "Thumbs down"
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    let mostrar_modal = false;
    let tipo_bloqueo = '';

    const bloqueRepseInicial = localStorage.getItem('BLOQUEO-REPSE-INICIAL');
    const bloqueRepse = localStorage.getItem('BLOQUEO-REPSE');

    if (bloqueRepseInicial) {
      if (bloqueRepseInicial == '1') {
        mostrar_modal = true;
        tipo_bloqueo = 'INICIAL';
      }
    }
    else if (bloqueRepse) {
      if (bloqueRepse == '1') {
        mostrar_modal = true;
        tipo_bloqueo = 'RECURRENTE';
      }
    }

    if (mostrar_modal) {
      Swal.fire({
        title: "<strong>BLOQUEO <u>REPSE</u></strong>",
        icon: "info",
        html: `Se le informa que su usuario tiene un <b>Bloqueo REPSE ${tipo_bloqueo}</b> por
            <a href="#/negocio_proveedores/repse/list" autofocus>Solicitudes Pendientes</a>,
            que no ha completado, por lo que <b>no podrá realizar Cargas y Validaciones de Facturas de Entrada</b> hasta que sea desbloqueado, revise su apartado REPSE en el MENU.
          `,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: `<i class="fa fa-thumbs-up"><a style="color:white;" href="#/negocio_proveedores/repse/list" autofocus> ${tipo_bloqueo == 'INICIAL' ? 'Revisar Solicitud Inicial REPSE' : 'Revisar Solicitudes REPSE'} </a></i> 
          `,
        confirmButtonAriaLabel: "Thumbs up, great!",
        cancelButtonText: `<i class="fa fa-thumbs-up"> Enterado</i>
          `,
        cancelButtonAriaLabel: "Thumbs down"
      });
    }
  }

  iniciarSesion(body?: Login) {
    this.authService
      .login(body!.user_name!, body!.password!)
      .subscribe(({ data }) => {
        this.modalLogin!.hide();
      });
  }
}
